import classNames from 'classnames/bind';
import { TripType } from 'contexts/searchParams';
import useAirportDetailList from 'hooks/useAirportDetailList';
import React, { useEffect, useMemo } from 'react';
import { GroupedSearchHistory } from '.';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  history: GroupedSearchHistory;
  setIsEvent: React.Dispatch<React.SetStateAction<boolean>>;
}

const Route = ({ history, setIsEvent }: IProps) => {
  const { histories, tripListCityCode, tripListCityName } = history;

  const [cityCodes, cityNames] = useMemo(() => {
    const codeList = tripListCityCode.split('|');
    const nameList = tripListCityName.split('|');
    if (histories?.[0]?.trip === TripType.RT) {
      codeList.pop();
      nameList.pop();
    }
    return [codeList, nameList];
  }, [histories, tripListCityCode, tripListCityName]);

  const { data } = useAirportDetailList(
    cityCodes.map(route => route.split('-')[1]),
  );

  useEffect(() => {
    if (data?.airportDetailList?.some(({ event }) => event)) {
      setIsEvent(true);
    }
  }, [data?.airportDetailList]);

  return cityCodes.flatMap((codes, index) => {
    const [departureCode, destinationCode] = codes.split('-');
    const [departureName, destinationName] = cityNames[index].split('-');
    return (
      <React.Fragment key={index}>
        <span className={cx('location')}>{departureName}</span>
        <span className={cx('code')}>{departureCode}</span> →&nbsp;
        <span className={cx('location')}>{destinationName}</span>
        <span className={cx('code')}>{destinationCode}</span>
        {index < cityCodes.length - 1 && ' / '}
      </React.Fragment>
    );
  });
};

export default Route;
